module.exports = __webpack_public_path__ + "static/media/mobile_locationpartners_food.73d3fc40.png";